import { render, staticRenderFns } from "./ModalViewEvent.vue?vue&type=template&id=597007a0&"
import script from "./ModalViewEvent.vue?vue&type=script&lang=js&"
export * from "./ModalViewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports